'use client';

import { Container, Grid, Stack, Typography } from '@mui/material';
import { useTranslations } from 'next-intl';
import Image from 'next/image';

import LinkComponent from '@/components/Link';
import colors from '@/styles/themes/colors';

import styles from './OfficeLocationSection.module.scss';

const OfficeLocationSection = () => {
  const t = useTranslations('office.location');

  return (
    <Container
      component="section"
      maxWidth={false}
      classes={{ root: styles.root }}
      disableGutters
      className={styles.container}
    >
      <Container maxWidth="xl" className={styles.content}>
        <Grid container spacing={{ xs: 3, lg: 4 }}>
          <Grid size={{ xs: 12, lg: 8 }}>
            <Stack position="relative" className={styles.imageWrapper}>
              <Image src="/images/home/team/team.webp" alt={t('imageAlt')} fill className={styles.teamImage} />
            </Stack>
          </Grid>
          <Grid size={{ xs: 12, lg: 4 }}>
            <Stack spacing={6} height="100%" justifyContent="space-between">
              <Stack spacing={3}>
                <Typography variant="h3" component="h2" color={colors.white}>
                  {t('title')}
                </Typography>
                <Stack spacing={0.5}>
                  <Typography variant="subtitle2" component="p" color={colors.white}>
                    {t('address.line1')}
                  </Typography>
                  <Typography variant="subtitle2" component="p" color={colors.white}>
                    {t('address.line2')}
                  </Typography>
                  <Typography variant="subtitle2" component="p" color={colors.white}>
                    {t('address.line3')}
                  </Typography>
                  <Typography variant="subtitle2" component="p" color={colors.white}>
                    {t('address.line4')}
                  </Typography>
                </Stack>
                <LinkComponent href={t('mapLink')} target="_blank" text={t('openInMaps')} />
              </Stack>
              <Stack spacing={2}>
                <Typography variant="subtitle1" component="p" color={colors.white}>
                  {t('contact.title')}
                </Typography>
                <Stack spacing={0.5}>
                  <a href={`mailto:${t('contact.email')}`} className={styles.contactLink}>
                    {t('contact.email')}
                  </a>
                  <a href={`tel:${t('contact.phone')}`} className={styles.contactLink}>
                    {t('contact.phone')}
                  </a>
                </Stack>
              </Stack>
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Container>
  );
};

export default OfficeLocationSection;
